const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const isAllowedFeature = require('module/user/helpers/is_allowed_feature')
const ContactMeForm = require('component/contact_me/form')
const log = require('log').create('profile', 'contact form') // eslint-disable-line

function ContactMeSection(props) {

    const { user } = props

    const show_contact_form = (
        user.contact_me.enabled
        && user.contact_me.display === 'form'
        && isAllowedFeature(user, 'contact_me')
    )

    if (! show_contact_form) return null

    const className = classNames([
        'contact-me-form',
        'inset',
    ], {
        editing: user.contact_me.editing,
        active: user.contact_me.active,
    })

    return (
        <section className={className}>
            <div className="meta-header">Contact Me</div>
            <ContactMeForm {...props} />
        </section>
    )

}

ContactMeSection.propTypes = {
    user: PropTypes.object.isRequired,
}

module.exports = ContactMeSection
